import { GetPolicyResponse } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getPolicyDetails = async (policyNumber?: string) => {
  if (!policyNumber) {
    return Promise.reject(new Error('Missing policyNumber'));
  }

  const { data } = await axios.get<GetPolicyResponse>(
    `${import.meta.env.VITE_POLICIES_API_URL}/v1/policies/${policyNumber}`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return data;
};

export const usePolicyDetailsQuery = (policyNumber?: string) =>
  useQuery({
    queryKey: ['policyDetails', policyNumber],
    queryFn: () => getPolicyDetails(policyNumber),
    enabled: !!policyNumber,
  });
